module.exports = __webpack_public_path__ + "media/images/athletes/88-8aa5ad9f229c0da2c60706ecbf2e63cb.png";